@if (initialized) {
  <div>
    <app-content-header (backEvent)="onBack()" [historyBack]="historyBack" [backLabel]="backLabel" [headline]="'payment_method_label' | i18next"></app-content-header>
    @if (!!company) {
      <app-icon-card>
        <h3 class="h3 red mb-3">{{ 'payment_method_sepa' | i18next }}</h3>
        <div>
          <app-sepa-form [bankAccount]="bankAccount" (formSubmit)="onNextSepa($event)" submitLabel="app_next"></app-sepa-form>
        </div>
      </app-icon-card>
    }
  </div>
}
